import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { downloadPDF } from "../utils/pdfDownload";

export default function ResultPage() {
  const navigate = useNavigate();
  const user = sessionStorage.getItem("user");

  const quiz = JSON.parse(sessionStorage.getItem("quizData") || "null");
  const answers = JSON.parse(sessionStorage.getItem("answers") || "{}");

  useEffect(() => {
    if (!user || !quiz) navigate("/");
  }, [user, quiz, navigate]);

  if (!quiz) return null;

  let score = 0;
  const resultList = quiz.questions.map((q) => {
    const userAns = answers[q.id];
    const correct = userAns === q.answer;
    if (correct) score++;
    return { ...q, userAns, correct };
  });

  const handleQuit = () => {
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <div className="container py-4">
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-body p-4">
          <div
            id="resultArea"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <h2 className="fw-bold">{quiz.title}</h2>
            <h5 className="text-muted">Result Sheet</h5>
            <hr />

            <h5>
              Name: <span className="fw-semibold">{user}</span>
            </h5>
            <h5>
              Score:{" "}
              <span className="fw-bold text-success">
                {score} / {quiz.questions.length}
              </span>
            </h5>

            <hr />

            {resultList.map((r, index) => (
              <div key={r.id} className="mb-3">
                <h6 className="fw-semibold">
                  {index + 1}. {r.question}
                </h6>
                <p className="mb-1">
                  Your Answer:{" "}
                  <span className="fw-semibold">
                    {r.userAns || "Not Answered"}
                  </span>
                </p>
                <p className="mb-1">
                  Correct Answer: <span className="fw-semibold">{r.answer}</span>
                </p>
                <span
                  className={`badge ${
                    r.correct ? "bg-success" : "bg-danger"
                  }`}
                >
                  {r.correct ? "Correct" : "Wrong"}
                </span>
                <hr />
              </div>
            ))}
          </div>

          <div className="d-flex flex-column flex-md-row gap-2 mt-3">
            <button
              className="btn btn-primary btn-lg"
              onClick={() =>
                downloadPDF("resultArea", { title: quiz.title, name: user })
              }
            >
              Download PDF 📄
            </button>

            <button className="btn btn-danger btn-lg" onClick={handleQuit}>
              Quit 🔚
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
